import "./index.css";
import React from 'react';
import ReactDOM from 'react-dom/client';

import reportWebVitals from './reportWebVitals';
import { PrimeReactProvider , } from 'primereact/api';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
// css utility

import 'boxicons/css/boxicons.min.css';
// my code for theme


import { createStore } from 'redux'

import { Provider } from 'react-redux'

import rootReducer from './redux/reducers'

// import 'primereact/resources/primereact.css';
import "primereact/resources/primereact.min.css";
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import './flags.css';
// import './index.css';
 import './Assest/css/Index.css';
 import './Assest/css/theme.css';
import App from './App';

const store = createStore(
  rootReducer
)


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
  <React.StrictMode>
    <PrimeReactProvider>
      <App />
    </PrimeReactProvider>
  </React.StrictMode>
  </Provider>,
);


reportWebVitals();
